/* ==================================================================
   North Shore Peptides — Collection page
   Filter drawer + auto-submit sort/filters.
   ================================================================== */
(function () {
  'use strict';

  function initCollection(root) {
    if (!root || root.dataset.npInit === 'true') return;
    root.dataset.npInit = 'true';

    /* ---- Sort: submit on change ---- */
    var sort = root.querySelector('.np-sort__select');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    /* ---- Filter drawer ---- */
    var drawer = root.querySelector('.np-filters');
    var openBtn = root.querySelector('.np-filter-toggle');
    var closeBtn = drawer && drawer.querySelector('.np-filters__close');
    var overlay = drawer && drawer.querySelector('.np-filters__overlay');

    function openDrawer() {
      if (!drawer) return;
      drawer.dataset.open = 'true';
      document.body.style.overflow = 'hidden';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.dataset.open = 'false';
      document.body.style.overflow = '';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    }
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  function initAll() { document.querySelectorAll('.np-collection').forEach(initCollection); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.np-collection');
    if (el) { el.dataset.npInit = ''; initCollection(el); }
  });
})();
